import { render, staticRenderFns } from "./InsightsViews.vue?vue&type=template&id=33ca7484"
import script from "./InsightsViews.vue?vue&type=script&lang=js"
export * from "./InsightsViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports